/**
 * @Author: DJ
 * @Date:   2021-07-09 15:03:56
 * @Last Modified by:   DJ
 * @Last Modified time: 2021-07-22 13:55:16
 */
import React from 'react';
import { Progress } from 'antd';
import styles from './index.module.scss';

const Index = (props) => {
  // eslint-disable-next-line react/prop-types
  const {loadInfo:{fileName,percent}} = props;
  return (
    <div className={styles.loading}>
      <div className={styles.loadingPng}></div>
      <div className={styles.loadingTitle}>正在上传，请耐心等待</div>
      <div className={styles.loadingStatus}>
      <div>{fileName}</div><Progress percent={percent} />
      </div>
    </div>
  );
};

export default Index;
